import type { Geo } from '@vercel/edge'

import { sentryLogging } from 'sentry-utils/logging'

export const getUserLocationInfo = async (host = '') => {
  try {
    const response = await fetch(`${host}/api/geolocation`)
    if (!response.ok) {
      throw new Error(`Failed to fetch location info: ${response.statusText}`)
    }
    const json = (await response.json()) as Geo
    return json
  } catch (error) {
    sentryLogging({
      team: 'team-day-visit-svartsengi',
      error,
      extras: { error },
    })
    return null
  }
}
